import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import Empresa from '../empresa/empresa';
import Fornecedor from '../fornecedor/fornecedor';
import Veiculo from '../veiculo/veiculo';
import UnidadeMedida from '../unidadeMedida/unidadeMedida';
import Produto from '../produto/produto';
import Cliente from '../cliente/cliente';
import AnalisePreco from '../analisePreco/analisePreco';
import PlanoConta from '../planoConta/planoConta';
import CentroCusto from '../centroCusto/centroCusto';
import Coleta from '../coleta/coleta';
import Aplicacao from '../aplicacao/aplicacao';
import Abastecimento from '../abastecimento/abastecimento';
import Agenda from '../agenda/agenda';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/empresa' component={Empresa} />
			<Route path='/fornecedor' component={Fornecedor} />
			<Route path='/veiculo' component={Veiculo} />
			<Route path='/unidadeMedida' component={UnidadeMedida} />
			<Route path='/produto' component={Produto} />
			<Route path='/produto' component={Produto} />
			<Route path='/cliente' component={Cliente} />
			<Route path='/analisePreco' component={AnalisePreco} />
			<Route path='/planoConta' component={PlanoConta} />
			<Route path='/centroCusto' component={CentroCusto} />
			<Route path='/coleta' component={Coleta} />
			<Route path='/aplicacao' component={Aplicacao} />
			<Route path='/abastecimento' component={Abastecimento} />
			<Route path='/agenda' component={Agenda} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
